var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack3Solid44({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18,7.53,6.36,6.9c.26-.29.53-.57.81-.83l.21-.21-.77-.17c-.3-.08-.5-.13-.6-.17l.32-.95a7.67,7.67,0,0,1,1.25.63,10.91,10.91,0,0,1-.12-1.43h1a13.57,13.57,0,0,1-.14,1.44A3.83,3.83,0,0,0,8.73,5c.32-.14.62-.27.89-.37l.28,1c-.39.09-.85.18-1.38.26l.65.73.3.36-.82.54-.72-1.2C7.71,6.68,7.46,7.09,7.18,7.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack3Solid44);
export default __webpack_public_path__ + "static/media/Symbolpack_3_solid_44.dfe8f4f437eb47e4cd13f3e130411bd2.svg";
export { ForwardRef as ReactComponent };